module.exports = __webpack_public_path__ + "static/media/logo_header.de2675c5.png";